export const SALUTATIONS = [
  "Mr",
  "Mrs",
  "Ms",
  "Miss",
  "Dr",
  "Prof",
  "Rev",
  "Fr",
  "Hon",
  "Sir",
  "Lord",
  "Lady",
  "Col",
  "Gen",
  "Judge",
  "Ambassador",
  "Chief",
] as const;

export const CUSTOM_SALUTATION_VALUE = "__custom_salutation__";
